import React from 'react'
import Svg from 'src/Components/shared/Svg'

const TeaserTextSvg = () => (
  <Svg
    width='46'
    height='41'
    viewBox='0 0 46 41'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M44.0279 36.7789H33.6319V40.8833L28.6326 36.7789H1.42057C0.637806 36.7789 0 36.1411 0 35.3584V8.42057C0 7.63781 0.637806 7 1.42057 7H44.0279C44.8107 7 45.4485 7.63781 45.4485 8.42057V35.368C45.4388 36.1508 44.8107 36.7789 44.0279 36.7789Z'
      fill='#535058'
    />
    <rect
      x='6'
      y='18'
      width='33'
      height='2.5'
      rx='1.25'
      fill='#BBB2B7'
      fillOpacity='0.2'
    />
    <rect
      x='6'
      y='23'
      width='33'
      height='2.5'
      rx='1.25'
      fill='#BBB2B7'
      fillOpacity='0.2'
    />
    <rect
      x='6'
      y='28'
      width='27'
      height='2.5'
      rx='1.25'
      fill='#BBB2B7'
      fillOpacity='0.2'
    />
    <path
      d='M28.6963 6.61822C28.6963 9.99866 25.9647 12.7364 22.5982 12.7364C19.2317 12.7364 16.5 9.99866 16.5 6.61822C16.5 3.23779 19.2317 0.5 22.5982 0.5C25.9647 0.5 28.6963 3.23779 28.6963 6.61822Z'
      fill='#37393B'
      stroke='#FC5AA6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.8964 7.35032C23.4569 7.35032 23.1005 6.99323 23.1005 6.5528C23.1005 6.11214 23.4571 5.75506 23.8964 5.75506C24.3364 5.75506 24.6926 6.11214 24.6926 6.5528C24.6926 6.99323 24.3364 7.35032 23.8964 7.35032ZM21.3135 7.35032C20.8738 7.35032 20.5174 6.99323 20.5174 6.5528C20.5174 6.11214 20.8738 5.75506 21.3135 5.75506C21.7533 5.75506 22.1097 6.11214 22.1097 6.5528C22.1097 6.99323 21.7533 7.35032 21.3135 7.35032ZM20.5434 9.49472H21.4141H23.7916H24.6555C24.9408 9.49472 25.1726 9.26267 25.1726 8.97664V8.09805H25.4758C25.6299 8.09805 25.7547 7.97302 25.7547 7.81908V6.69089C25.7547 6.53672 25.6299 6.41192 25.4758 6.41192H25.1726V5.3056C25.1726 5.0198 24.941 4.78774 24.6555 4.78774H22.743V4.47712C23.1323 4.41449 23.43 4.07654 23.43 3.66867C23.43 3.2164 23.0641 2.84998 22.6127 2.84998C22.1614 2.84998 21.7957 3.2164 21.7957 3.66867C21.7957 4.06492 22.0764 4.39513 22.4498 4.47097V4.78774H20.5431C20.2579 4.78774 20.0263 5.01957 20.0263 5.3056V6.41192H19.719C19.5652 6.41192 19.4406 6.53695 19.4406 6.69089V7.81908C19.4406 7.97302 19.5654 8.09805 19.719 8.09805H20.0265V8.97664C20.0265 9.26267 20.2579 9.49472 20.5434 9.49472ZM20.7091 8.42926C20.7091 8.2406 20.8621 8.08767 21.0507 8.08767H24.2313C24.4199 8.08767 24.5729 8.2406 24.5729 8.42926C24.5729 8.61792 24.4199 8.77086 24.2313 8.77086H21.0507C20.8621 8.77086 20.7091 8.61792 20.7091 8.42926Z'
      fill='white'
    />
  </Svg>
)

export default TeaserTextSvg
